import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import T from '../../Utils/Locale';
import PurchaseType from '../Purchase/PurchaseType';
import Button from '../../Components/ComponentButton';
function AdviceShowBookings({ selectTab, product, bookings }) {
    const getPurchaseType = (booking) => {
        let purchaseType = null;
        booking.items.forEach((item) => {
            if (item.document.type === product) {
                purchaseType = item.purchase_type;
            }
        });
        return purchaseType;
    };
    return (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: 'tailwind-reset text-base font-medium mb-5 md:pt-4' }, { children: T('dashboard.advice.headline_has_booking') })), bookings.map((booking) => (_jsxs("div", { children: [_jsx("p", { children: T(booking.status === 'completed' ? 'dashboard.booking_completed' : 'dashboard.booking', {
                            time: booking.bookedMinutes,
                            type: T(`purchase_type.${getPurchaseType(booking)}`).toLowerCase(),
                            date: booking.date
                        }) }), getPurchaseType(booking) === PurchaseType.REVIEW && (_jsx(Button, { title: T('dashboard.upgrade_to_advice'), classes: 'btn border-solid xs:text-sm text-lg tailwind-reset bg-white border border-dark-teal text-dark-teal xs:px-8 px-10 hover:text-white active:shadow-outline', onClick: () => selectTab(3) }))] }, booking.date)))] }));
}
AdviceShowBookings.propTypes = {
    selectTab: PropTypes.func.isRequired,
    bookings: PropTypes.array.isRequired
};
export default AdviceShowBookings;
